import { action as apiAction } from 'api/Api'
import {
  removeResponsible,
  removeUser
} from '../redux/cards'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  userId: number
  id: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { id, userId } = payload

  const card = getState()['view-board'].cards[id]

  let optimisticAction
  if (card) {
    const currentResponsible = card.responsible

    if (userId === currentResponsible) {
      optimisticAction = optimisticDispatch(dispatch, removeResponsible({
        id
      }))
    } else {
      optimisticAction = optimisticDispatch(dispatch, removeUser({
        id,
        userId
      }))
    }
  }

  try {
    await apiAction('RemoveUserFromCard', {
      cardId: id,
      userId
    })
  } catch (error) {
    if (error.code === 501) {
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['CARD_REMOVE_USER_VALIDATE'],
          type: 'info'
        })
      } catch (e) {}
    } else if (error.code !== 401) {
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}
